const { createSlice } = require('@reduxjs/toolkit');



export function getfetchOrderDetails(
  brn,
  endDate,
  groupName,
  startDate,
  pageNumber = 0,
  itemPerPage = 5,
  msisdn,
  advSearch
  // phoneNum = '',
  // qname = '',
  // router,
  // screen = ''
) {
  // console.log("REDUX", brn,
  //  endDate,
  //  groupName,
  //  startDate,   
  //  pageNumber,
  //  itemPerPage,)
  return async function getfetchOrderDetailsBulk(dispatch, getState) {
    try {


      // msisdn: phoneNum,
      // source: 'BizCare',
      // pageStart: pageNumber,
      // pageCount: itemPerPage,
      let param = {}
      if (advSearch === true) {
        console.log("inside adv")
        param = JSON.stringify({
          brn: brn,
        });
      }
      else {
        console.log("outside adv")
        param = JSON.stringify({
          brn: brn,
        });
      }


      dispatch(getBulkDataOrder({ data: {}, loading: true }));

      let response = await fetch(
        `/bizcareui/api/SupportEnquiry/orderEnquiryDetails`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: param,
        }
      );

      let json = await response.json();
      console.log('API Response in redux:', json);
      if (json?.status?.statusType === 'INFO') {
        dispatch(
          getBulkDataOrder({ data: json, loading: false, error: '' })
        );
        dispatch(
          getVDBtotalSize(
            json?.totalRecord
          )
        );
      }
      else if (json?.error) {
        dispatch(
          getBulkDataOrder({
            data: [],
            loading: false,
            error: `Technical failure : Couldn't able to retrieve customer detail`,
            modalIsOpenError: true,
          })
        );
      }
    }
    catch (error) {
      dispatch(
        getBulkDataOrder({
          data: [],
          loading: false,
          error: `Technical failure : Couldn't able to retrieve customer detail`,
          modalIsOpenError: true,
        })
      );
    }
  };
}


const initialState = {
  itemPerPage: 5,
  pageNumber: 0,
  totalSize: 0,
  VDBReplicatedData: [],
  bulkDataOrder: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  bulkDataOrderResDetails: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
};
const bulkOrderData = createSlice({
  name: 'getBulkOrderData',
  initialState,
  reducers: {
    getBulkDataOrder: (state, action) => {
      state.bulkDataOrder = action.payload;
    },

    getItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
    },
    getpageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    getVDBtotalSize: (state, action) => {
      state.totalSize = action.payload;
    },
    getVDBReplicatedData: (state, action) => {
      if (action.payload === undefined && state.VDBReplicatedData?.length > 0) {
        state.VDBReplicatedData.length = 0;
      } else if (
        state.VDBReplicatedData?.length > 0 &&
        action.payload.length > 0
      ) {
        state.VDBReplicatedData = [
          ...state.VDBReplicatedData,
          ...action.payload,
        ];
      } else if (state.VDBReplicatedData?.length === 0) {
        state.VDBReplicatedData = action.payload;
      } else {
        // state.VDBReplicatedData.length = 0;
        state.VDBReplicatedData = [];
      }
    },
    resetBulkOrderData: () => initialState,
  },
});
export const {
  getBulkDataOrder,
  getItemPerPage,
  getpageNumber,
  getVDBtotalSize,
  getVDBReplicatedData,
  resetBulkOrderData,
} = bulkOrderData.actions;
export default bulkOrderData.reducer;
